"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const TextColor = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement("path", { d: "M10.652 6.76 5.65 19.83h2.724l1.15-3.15h4.895l1.171 3.15h2.767L13.355 6.76h-2.703Zm1.32 3.279 1.596 4.342h-3.193l1.597-4.342Z" })
  );
};
export default TextColor;
